import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { TourPlayer } from "@/components/TourPlayer";

// New here? MiLu shows you around once, on your first visit.
export const FirstTourDialog = () => {
  const { user } = useAuth();
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (!user) return;
    api.get("/tour/first-time")
      .then(({ data }) => setOpen(Boolean(data.show)))
      .catch(() => {});
  }, [user]);

  const close = () => {
    setOpen(false);
    api.post("/tour/shown").catch((e) => console.error("could not mark the tour as shown", e));
  };

  if (!user) return null;

  return (
    <Dialog open={open} onOpenChange={(next) => (next ? setOpen(true) : close())}>
      <DialogContent className="max-w-3xl border-white/10 bg-panel" data-testid="first-tour-dialog">
        <DialogHeader>
          <DialogTitle className="font-display text-xl">
            Welcome{user.name ? `, ${user.name.split(" ")[0]}` : ""} — here is the 60-second tour
          </DialogTitle>
        </DialogHeader>
        <p className="text-sm text-ink-soft">
          MiLu shows you around in your own language. You will only see this once.
        </p>
        <TourPlayer compact page="signup" />
        <div className="mt-2 flex flex-wrap justify-end gap-2">
          <Button
            data-testid="first-tour-later"
            variant="outline"
            onClick={close}
            className="min-h-[40px] rounded-full px-5"
          >
            Skip for now
          </Button>
          <Button
            data-testid="first-tour-done"
            onClick={close}
            className="min-h-[40px] rounded-full bg-brand px-5 hover:bg-brand-hover"
          >
            Got it, let me in
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};
